import React, { Fragment, useEffect, useMemo, useState } from "react";
import { ROUTES } from "../../constants/routes";
import { useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "../../components/UI/loadingSpinner/LoadingSpinner";
import { Link } from "react-router-dom";
import { IEmployee } from "../../interfaces/employee.interface";
import { getApi } from "../../services/http.service";
import moment from "moment";
import { Icon } from "@iconify/react";
import { IDaySale, IProduct } from "../../interfaces/daysales.interface";
import DataTable, { TableColumn } from "react-data-table-component";
import { totalCases } from "../../utils";
import { IShop } from "../../interfaces/shop.interface";

const SaleDetail = () => {
  const fUrl = process.env.REACT_APP_FILE_URL;
  const params = useParams();
  const navigate = useNavigate();
  const [sale, setSale] = useState<IDaySale>();
  const [employee, setEmployee] = useState<IEmployee>();
  const [shop, setShop] = useState<IShop>();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    fetchSaleData();
  }, []);

  const fetchSaleData = async () => {
    try {
      const result = await getApi(ROUTES.SALES_BY_ID + params?.id);
      setSale(result?.data);
      setEmployee(result?.data?.employee);
      setShop(result?.data?.shop);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const columns: TableColumn<IProduct>[] = useMemo(
    () => [
      {
        name: "  Image",
        cell: (row: any) => (
          <img
            height={60}
            width={60}
            className="p-2 text-center"
            style={{ objectFit: "contain" }}
            src={fUrl + row.product?.image}
            alt={row.name}
          />
        ),
        width: "100px",
      },
      {
        name: "Product",
        selector: (row: any) => row.product?.name || "-",
        width: "200px",
      },
      {
        name: "Group",
        selector: (row: any) => row.product?.group || "-",
        width: "200px",
      },
      {
        name: "Volume",
        selector: (row: any) => row.product?.volume || "-",
        width: "200px",
      },
      {
        name: "Price",
        selector: (row: any) => row.product?.price || "-",
        width: "200px",
      },
      {
        name: "Cases",
        selector: (row: any) => row.cases || "-",
        width: "200px",
      },
    ],
    []
  );
  if (loading) {
    return <LoadingSpinner />;
  }
  return (
    <>
      <div>
        <div className="d-flex">
          <button className="nav-link" onClick={() => navigate(-1)}>
            <Icon icon="material-symbols:arrow-back-rounded" fontSize={25} />
          </button>
          <h4 className="ms-2">Sale Details</h4>
        </div>
        <section>
          <div className="table-responsive my-3">
            <table className="table table-bordered table-striped">
              <tbody>
                <tr>
                  <th>Employee</th>
                  <td>{employee?.fullName}</td>
                  <th>Email</th>
                  <td>{employee?.email}</td>
                </tr>
                <tr>
                  <th>Phone</th>
                  <td>{employee?.phone}</td>
                  <th>Designation</th>
                  <td>{employee?.designation}</td>
                </tr>
                <tr></tr>

                <tr>
                  <th>Address</th>
                  <td>
                    <div>{employee?.address?.street}</div>
                    <div>
                      {employee?.address?.city}, {employee?.address?.state},{" "}
                      {employee?.address?.pincode}
                    </div>
                  </td>
                  {Number(employee?.workingCities?.length) > 0 && (
                    <>
                      <th>Working Cities</th>
                      <td>
                        {employee?.workingCities?.map((ct, index) => (
                          <span
                            key={index}
                            className="px-2 border rounded me-2 fs-6"
                          >
                            {ct}
                          </span>
                        ))}
                      </td>
                    </>
                  )}
                </tr>
                {Number(employee?.reporters?.length) > 0 && (
                  <tr>
                    <th>Reporters</th>
                    <td colSpan={3} className="d-flex gap-3">
                      {employee?.reporters?.map((reporter, index) => (
                        <Link
                          key={index}
                          className="nav-link text-primary text-hover-underline"
                          to={`/reporter/${reporter}`}
                        >
                          View Reporter
                        </Link>
                      ))}
                    </td>
                    <th>Shop</th>
                    <td>{shop?.shopName}</td>
                  </tr>
                )}
                <tr>
                  <th>Shop Owner</th>
                  <td>{shop?.shopOwner}</td>
                  <th>Shop Address</th>
                  <td>
                    {shop?.shopAddress} {shop?.shopCity} {shop?.shopState}
                  </td>
                </tr>
                <tr>
                  <th>Delivery Date</th>
                  <td>{moment(sale?.deliveryDate).format("DD/MM/YYYY")}</td>
                  <th>Order Taken</th>
                  <td>{sale?.orderNotTaken ? "No" : "Yes"}</td>
                </tr>
                <tr>
                  <th>Added On</th>
                  <td>{moment(sale?.addedAt).format("DD/MM/YYYY hh:mm A")}</td>
                  <th>Remark</th>
                  <td>{sale?.remark != "false" ? sale?.remark : "-"} </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div>
            <h6>Products</h6>
          </div>
          <DataTable
            columns={columns}
            data={sale?.products || []}
            highlightOnHover
            striped
            progressPending={loading}
            progressComponent={<LoadingSpinner />}
          />
        </section>
      </div>
    </>
  );
};

export default SaleDetail;
